// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import TableController from "./table_controller"
application.register("table", TableController)

import DeleteController from "./delete_controller"
application.register("delete", DeleteController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import SortableTableController from "./sortable_table_controller"
application.register("sortable-table", SortableTableController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import ResizableTableController from "./resizable_table_controller"
application.register("resizable-table", ResizableTableController)

import TermsValidationController from "./terms_validation_controller"
application.register("terms-validation", TermsValidationController)

import FavoritesController from "./favorites_controller"
application.register("favorites", FavoritesController)

import PropertyGalleryController from "./property_gallery_controller"
application.register("property-gallery", PropertyGalleryController)

import ReportAgreementController from "./report_agreement_controller"
application.register("report-agreement", ReportAgreementController)

import MapController from "./map_controller"
application.register("map", MapController)

import GeocoderController from "./geocoder_controller"
application.register("geocoder", GeocoderController)

import AreaMapController from "./area_map_controller"
application.register("area-map", AreaMapController)

import StripeReservationController from "./stripe_reservation_controller"
application.register("stripe-reservation", StripeReservationController)

import SpeciesFilterController from "./species_filter_controller"
application.register("species-filter", SpeciesFilterController)

import ReservationFormController from "./reservation_form_controller"
application.register("reservation-form", ReservationFormController)

import AvailabilityCalendarController from "./availability_calendar_controller"
application.register("availability-calendar", AvailabilityCalendarController)

import AvailabilityEditorController from "./availability_editor_controller"
application.register("availability-editor", AvailabilityEditorController)

import OccupancyPaintController from "./occupancy_paint_controller"
application.register("occupancy-paint", OccupancyPaintController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import HuntGameController from "./hunt_game_controller"
application.register("hunt-game", HuntGameController)
import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import HeatmapController from "./heatmap_controller"
application.register("heatmap", HeatmapController)

import AiDescriptionController from "./ai_description_controller"
application.register("ai-description", AiDescriptionController)

import SubmissionChecklistController from "./submission_checklist_controller"
application.register("submission-checklist", SubmissionChecklistController)

import PropertyWizardController from "./property_wizard_controller"
application.register("property-wizard", PropertyWizardController)

import PhotoManagerController from "./photo_manager_controller"
application.register("photo-manager", PhotoManagerController)
